var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaylistPlusIcon = function SvgPlaylistPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 1a1 1 0 0 1 1-1h15a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1M16.05 4.7a1 1 0 0 1 1 1v3.85h3.85a1 1 0 1 1 0 2h-3.85v3.85a1 1 0 1 1-2 0v-3.85H11.2a1 1 0 1 1 0-2h3.85V5.7a1 1 0 0 1 1-1M1 6.5a1 1 0 0 0 0 2h5.2a1 1 0 1 0 0-2zM1 13a1 1 0 1 0 0 2h5.2a1 1 0 1 0 0-2z"
  })));
};
export default SvgPlaylistPlusIcon;